// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"tt-z","heading":"ut-z","screenReadersOnly":"vt-z"};